import BrandsSubscriptionsFull from './components/BrandsSubscriptionsFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
var BrandsSubscriptionsOption = {
    key: 'brandsSubscriptionsOption',
    titleStringKey: 'optionTitle_subscriptionActions',
    searchTermsStringKey: 'optionTitle_subscriptionActions',
    hideTitleInFullOptions: true,
    fullOptionFormSettings: {
        render: function () { return React.createElement(BrandsSubscriptionsFull, null); },
        isDirty: function () { return false; },
        onSave: function () {
            return Promise.resolve();
        },
        onDiscard: function () {
            return;
        },
        hideSaveDiscard: function () {
            return true;
        },
    },
    isHidden: function () { return !isControlFeatureEnabled('doc-brandsSubscriptions'); },
};
export default BrandsSubscriptionsOption;
//# sourceMappingURL=BrandsSubscriptionsOption.js.map